import { render, staticRenderFns } from "./merge-tags.vue?vue&type=template&id=ec55ec46&"
import script from "./merge-tags.vue?vue&type=script&lang=js&"
export * from "./merge-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports